import request from '@/utils/request'
//登录
export function login(data) {
  return request({
    // url: '/vue-admin-template/user/login',
    url: '/console/login',
    method: 'post',
    data
  })
}

export function userUpdate(data) {
  return request({
    url: '/console/update_user_name',
    method: 'post',
    data
  })
}
export function update_user(data) {
  return request({
    url: '/console/update_user',
    method: 'post',
    data
  })
}
export function disable_user(data) {
  return request({
    url: '/console/disable_user',
    method: 'post',
    data
  })
}